import { computed, makeObservable, observable } from 'mobx';
import { PaginationProps } from '../models';
import { Identifiable } from '@custis/common';

type PaginationPropsActions<TItem extends Identifiable> = Pick<
  PaginationProps<TItem>,
  'gotoPage' | 'nextPage' | 'previousPage' | 'setPageSize'
>;
type PaginationPropsData<TItem extends Identifiable> = Pick<
  PaginationProps<TItem>,
  'canPreviousPage' | 'canNextPage' | 'pageSize' | 'pageCount' | 'pageIndex'
>;

export class PaginationService<TItem extends Identifiable> {
  // Не удаляйте = undefined: без этого mobx перестает отслеживать изменения
  @observable.ref private paginationPropsActions?: PaginationPropsActions<TItem> = undefined;

  // Не удаляйте = undefined: без этого mobx перестает отслеживать изменения
  @observable.ref private paginationPropsData?: PaginationPropsData<TItem> = undefined;

  constructor() {
    makeObservable(this);
  }

  getPagingCount(pageSize: number, totalCount?: number): number {
    if (totalCount) {
      const residue = totalCount % pageSize === 0 ? 0 : 1;
      return Math.floor(totalCount / pageSize) + residue;
    }
    return 1;
  }

  setPaginationPropsActions(actions: PaginationPropsActions<TItem>): void {
    this.paginationPropsActions = actions;
  }

  setPaginationPropsData(data: PaginationPropsData<TItem>): void {
    this.paginationPropsData = data;
  }

  @computed
  get paginationProps(): PaginationProps<TItem> | undefined {
    return this.paginationPropsActions && this.paginationPropsData
      ? {
          ...this.paginationPropsData,
          ...this.paginationPropsActions,
        }
      : undefined;
  }
}
